import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';

import Logout from 'src/ConnectedComponents/Logout';
import ContactUs from 'src/components/ContactUs';
import Logo from 'src/ConnectedComponents/utils/Logo';
import LoadingDots from 'src/assets/loading_dots.svg';
import styles from '../index.css';
import { checkAuthorization } from 'src/utils/checkAuthorization';

import { requestCreateBlackbaudUser } from 'src/redux/blackbaudUsers/blackbaudUser.action';
import {
	fetchAuthOrganizations,
	requestUpdateAuthOrganization,
} from 'src/redux/authOrganizations/authOrganization.action';
import { getAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';
import { Heading } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

@withRouter
class BlackbaudAuthCallback extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	async componentDidMount() {
		const isAuthenticated = checkAuthorization();
		let oauthCode = queryString.parse(this.props.location.search).code;

		if (!isAuthenticated) {
			if (oauthCode) {
				localStorage.oauthCode = oauthCode;
			}

			this.setState({ loggedIn: false });
			return;
		}

		if (!oauthCode && localStorage.oauthCode) {
			oauthCode = localStorage.oauthCode;
		}

		if (!oauthCode) {
			window.toast('no authorization code received', {
				onClose: () => this.setState({ failed: true }),
			});
			return;
		}

		// if we got this far, we don't want an oauthCode hanging around
		delete localStorage.oauthCode;

		// make sure we have our auth org
		await this.props.fetchAuthOrganizations();

		try {
			const bbUserResponse = await this.props.requestCreateBlackbaudUser({ code: oauthCode });
			await this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
				blackbaud_environment_id: bbUserResponse.payload.environment_id,
			});
			this.setState({ done: true });
		} catch (e) {
			window.toast('error processing auth: ' + e.message, {
				onClose: () => this.setState({ failed: true }),
			});
		}
	}

	render() {
		if (this.state.loggedIn === false) {
			return (
				<Redirect
					to={{
						pathname: '/login',
						from: this.props.location,
					}}
				/>
			);
		}

		if (this.state.done) {
			return <Redirect to="/" />;
		}

		if (this.state.failed) {
			return (
				<div className={styles.SetupContent}>
					<Logout />
					<Logo />
					<div className={styles.SetupCardLayout}>
						<Heading {...theme.heading.setUpTitle}>Something went wrong</Heading>
						<ContactUs />
					</div>
				</div>
			);
		}

		// otherwise, render loading dots while we're waiting for the callback to finish
		return (
			<LoadingDots
				style={{ width: '40px', margin: '0 auto', marginTop: '300px', display: 'block' }}
			/>
		);
	}
}

const mapStateToProps = state => ({
	authOrganizations: getAuthOrganizations(state),
});

const actions = {
	fetchAuthOrganizations,
	requestCreateBlackbaudUser,
	requestUpdateAuthOrganization,
};

BlackbaudAuthCallback = connect(mapStateToProps, actions)(BlackbaudAuthCallback);

export default BlackbaudAuthCallback;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/BlackbaudAuthCallback/index.js